// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"252":"1517c1f7","390":"ba09517f","457":"e8570c61","746":"a8d7d618","767":"1b79bc42","776":"fce11576","915":"999fca28"}[chunkId] + ".chunk.js";
};